import { defineComponent as _defineComponent } from 'vue'
import { VignetteHelpers } from "@/types";
import Vue, { ref, toRefs, getCurrentInstance, onMounted } from "vue";
import { LogService } from "@/services";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePanel',
  props: {
    label: { default: "Default title" },
    html: { default: "" },
    highlight: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { label: string, html: string, highlight: boolean, readonly: boolean };


const { label, html, highlight, readonly } = toRefs(props);
const panel = ref<Vue | null>(null);

const onChange = (): void => {
  // Note: we'll capture the value before click is processed, so we should capture collapsed status
  if (
    panel.value?.$el &&
    panel.value.$el.className.indexOf("v-expansion-panel--active") < 0
  ) {
    VignetteHelpers.Analytics.push({
      ["event"]: "vignette-profile-section-click",
      ["custom.gtm.elementText"]: label.value,
      ["custom.gtm.elementUrl"]: "",
    });
  }
};
const instance = getCurrentInstance();
const { slots } = instance?.proxy;
onMounted(() => {
  if (html.value === "No information available." && slots?.body) {
    LogService.error(
      `Component with label: ${label.value} might be incorrectly visible. Check v-if's and/or for missing data`
    );
  }
});

return { __sfc: true,props, label, html, highlight, readonly, panel, onChange, instance, slots }
}

})